import { ChatMessage } from '../../pingu/types';

const pillLabel = (loading: boolean, lastMessage: ChatMessage | undefined): string => {
  if (loading) return 'Pingwin is answering…';
  if (lastMessage?.role === 'user' || lastMessage?.connectionLost) return 'Pingwin is still working';
  if (lastMessage?.error || lastMessage?.emptyReply) return "Pingwin couldn't answer";
  return 'Pingwin has answered';
};

export default pillLabel;
